<template>
  <div
    id="up-navigation-navbar-container"
    class="fixed bg-white top-0 w-[calc(100vw-theme(spacing.18))] left-18 z-20 tracking-normal"
  >
    <slot />
  </div>
</template>
